module.exports = __webpack_public_path__ + "img/yiliao_image.9cedfaab.png";